const localizers = {
  'loading.msg': () => `Ładowanie...`,
  'SASServer.genericError.msg': () => `Nie można połączyć się z serwerem.`,
  'SASReport.genericError.msg': () => `Nie można załadować wybranego raportu.`,
  'SASReportImage.genericError.msg': () => `Nie udało się załadować obrazu raportu.`,
  'SASReportImage.imageNotSupported.msg': () => `Dla tego typu zawartości raportu obrazy nie są obsługiwane.`,
}
export default localizers;
